import { apiClient } from './client';
import { listDivisions, listAllTeams } from './organization';
import type { SelectOption } from '../lib/approval-select';

/**
 * 서식 「고르기」 칸의 **목록 주인들** (2026-08-28 · 자리 재정의 판 9).
 *
 * ★★ **여기서 목록을 만들지 않는다.** 이 파일이 하는 일은 «주인에게 물어보는 것»뿐이다 —
 *    휴가 종류는 근태 기준 설정(판 7)이, 부서·팀은 조직도가 주인이다.
 *    목록을 서식 쪽에 베껴 두면 한 값을 두 자리에서 고치게 되고, 반드시 한쪽만 고쳐진다.
 *
 * ★ **부서·팀은 이미 열린 길을 쓴다**(`/organization/*`) — 전 직원이 조직도를 본다.
 *   `hr/org-leaders` 는 담당자 전용이라 기안자가 못 쓴다(그래서 그쪽을 안 쓴다).
 *
 * ★★ **기준 설정 서버가 아직 없을 수 있다.** 판 7 이 다른 브랜치라, 이 화면이 먼저 나가면
 *    `/company-codes` 는 404 다 — 그때는 **빈 목록**이고 화면이 그 사실을 말한다.
 *    기안 자체는 막지 않는다(못 고르는 칸 하나가 결재를 통째로 막으면 안 된다).
 *
 * ★★★ **코드까지 준다** (2026-09-04 · 예산 판 B0). 예전에는 `.map((c) => c.label)` 로
 *      **이름만 남기고 코드를 버렸다** — 서버는 처음부터 코드를 함께 보내고 있었다.
 *      값이 `{code,label}` 이 되면서 코드가 필요해졌고, **부를 곳을 더 늘리지 않고**
 *      이미 오던 값을 안 버리는 것으로 끝났다.
 * ★ 부서·팀은 **조직도의 id 가 코드**다(코드 목록이 따로 없다).
 */

/** 근태·인사 기준 설정의 한 목록 — **쓰는 값**을 코드와 이름으로 받는다. */
export async function fetchCodeOptions(setKey: string): Promise<SelectOption[]> {
  const { data } = await apiClient.get<{ codes?: Array<{ code: string; label: string; active: boolean }> }>(
    `/company-codes/${setKey}`,
  );
  return (data.codes ?? [])
    .filter((c) => c.active)
    .map((c) => ({ code: c.code, label: c.label }));
}

/** 조직도의 부서 — 코드는 **조직 id** 다(이름이 바뀌어도 가리키는 곳은 그대로다). */
export async function fetchDivisionNames(): Promise<SelectOption[]> {
  return (await listDivisions()).map((d) => ({ code: String(d.id), label: d.name }));
}

/** 조직도의 팀 — 부서를 안 고르고 **전사**를 받는다(서식 칸은 부서를 안 묻는다). */
export async function fetchTeamNames(): Promise<SelectOption[]> {
  return (await listAllTeams()).map((t) => ({ code: String(t.id), label: t.name }));
}
